import { FunctionComponent } from "react";
import TiposDocumentos from "../../../pages/admin-archivos/tipos-documentos/Main";
import Regiones from "../../../pages/admin-archivos/regiones/Main";
import Instancias from "../../../pages/admin-archivos/instancias/Main";
import Delitos from "../../../pages/admin-archivos/delitos/Main";
import Distritos from "../../../pages/admin-archivos/distritos/Main";
import Areas from "../../../pages/admin-archivos/areas/Main";
import TiposFolder from "../../../pages/admin-archivos/tipos-folder/Main";
import Materias from "../../../pages/admin-archivos/materias/Main";
import Epocas from "../../../pages/admin-archivos/epocas/Main";

const rutasComplArchivos: Array<{ path: string; elemento: FunctionComponent }> =
  [
    { path: "/tipos-documentos", elemento: TiposDocumentos },
    { path: "/regiones", elemento: Regiones },
    { path: "/instancias", elemento: Instancias },
    { path: "/delitos", elemento: Delitos },
    { path: "/distritos", elemento: Distritos },
    { path: "/areas", elemento: Areas },
    { path: "/tipos-folder", elemento: TiposFolder },
    { path: "/materias", elemento: Materias },
    { path: "/epocas", elemento: Epocas },
  ];

export default rutasComplArchivos;
